function throttle(func, context, delay, text, mustApplyTime) {
  const fn = func;
  clearTimeout(fn.timer);
  fn._cur = Date.now();
  if (!fn._start) {
    fn._start = fn._cur;
  }
  if (fn._cur - fn._start > mustApplyTime) {
    fn.call(context, text);
    fn._start = fn._cur;
  } else {
    fn.timer = setTimeout(() => {
      fn.call(context, text);
    }, delay);
  }
}

export default throttle;
